import {INIT_URL, SIGNOUT_USER_SUCCESS, USER_DATA, USER_TOKEN_SET,USER_STATISTICS_DETAILS} from "../../constants/ActionTypes";

const INIT_STATE = {
  token: localStorage.getItem("adminToken"),
  initURL: "",
  getStatistic: {},
};

const authReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload,
      };
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state, 
        token: null,
        authUser: null,
        initURL: "",
      };
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    case USER_STATISTICS_DETAILS: {
      return {
        ...state,
        getStatistic: action.statistic,
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    default:
      return state;
  }
};

export default authReducer;
